module.exports = __webpack_public_path__ + "static/media/group_6@2x.93258508.png";